import { render, staticRenderFns } from "./GoodsLst.vue?vue&type=template&id=0651c94b&scoped=true"
import script from "./GoodsLst.vue?vue&type=script&lang=js"
export * from "./GoodsLst.vue?vue&type=script&lang=js"
import style0 from "./GoodsLst.vue?vue&type=style&index=0&id=0651c94b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0651c94b",
  null
  
)

export default component.exports